// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const V1VolumeType = {
  VolumeTypeGP3: 'gp3',
  VolumeTypeIO1: 'io1',
  VolumeTypeIO2: 'io2',
  VolumeTypePDBalanced: 'pd-balanced',
  VolumeTypePDSSD: 'pd-ssd',
  VolumeTypeHyperdiskBalanced: 'hyperdisk-balanced',
  VolumeTypeTopoLVM: 'topolvm',
} as const;
export type V1VolumeType = (typeof V1VolumeType)[keyof typeof V1VolumeType];

export function instanceOfV1VolumeType(value: any): boolean {
  for (const key in V1VolumeType) {
    if (Object.prototype.hasOwnProperty.call(V1VolumeType, key)) {
      if (V1VolumeType[key as keyof typeof V1VolumeType] === value) {
        return true;
      }
    }
  }
  return false;
}

export function V1VolumeTypeFromJSON(json: any): V1VolumeType {
  return V1VolumeTypeFromJSONTyped(json, false);
}

export function V1VolumeTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1VolumeType {
  return json as V1VolumeType;
}

export function V1VolumeTypeToJSON(value?: V1VolumeType | null): any {
  return value as any;
}

export function V1VolumeTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): V1VolumeType {
  return value as V1VolumeType;
}
